export type InstantSearchBranchChipProps = {
  branchName: string;
  resetBranch: VoidFunction;
};

const InstantSearchBranchChip = ({
  branchName,
  resetBranch,
}: InstantSearchBranchChipProps) => {
  return (
    <div className="ch-mt--n1 sm:ch-mt--0 ch-mb--1">
      <ul className="ch-display--flex sm:ch-justify-content--center">
        <button
          className="searchtag ac-instant-search__branch-chip"
          onClick={resetBranch}
          type="button"
        >
          {branchName}
        </button>
      </ul>
    </div>
  );
};

export default InstantSearchBranchChip;
